import styled from 'styled-components';

import tw from 'tailwind-styled-components';

export const BigNumbersContainer = tw.div`
  flex
  items-center
  justify-center
  flex-wrap
`;
const ItemNumberContainerStyle = styled.div`
  @media (max-width: 374px) {
    width: 276px;
  }

  @media (min-width: 375px) {
    width: 302px;
  }
`;
export const ItemNumberContainer = tw(ItemNumberContainerStyle)`
  rounded-2xl
  border
  border-corporate-blue
  text-center
  overflow-hidden
  mb-10
  mr-3
`;
export const TopNumber = styled.div`
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 640px) {
    height: 200px;
  }
`;
export const BottomNumber = tw.div`
  relative
`;

export const ContentTopCurve = styled.div`
  position: absolute;
  bottom: 100%
  left: -20px;
  width: calc(100% + 40px);
  line-height: 0;

  @media (min-width: 640px) {
      bottom: 100%;
      left: -40px;
    width: calc(100% + 80px);
  }
`;
export const BottomText = styled.div<{
  className?: string;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
}>`
  hyphens: auto;
`;

export const SvgContainer = styled.div`
  width: 100%;
  height: 100px;
`;
